export const API_PATH_ApiTrafficStudyCommentPost = '/services/traffic-studies/apiTrafficStudyCommentPost';
